import Player from '@vimeo/player'
import getVideoId from 'get-video-id'

import EventBus from '@/js/util/EventBus'
import player from '@/js/util/props/player'

export default {
  props: {
    ...player,

    backgroundVideo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      toggle: false,
      isPlaying: false,
      player: undefined,
    }
  },

  computed: {
    determineModalUsage() {
      if (!this.useModal) {
        return false
      }
      return window.innerWidth >= 768
    },
  },

  created() {
    EventBus.$emit('set:button', this.playerId)
    // if you are using this with the modal you
    // will have to pass in the prop useModal
    EventBus.$on(`toggle:${this.determineModalUsage ? 'modal' : 'video'}`, this.maybeToggle)
  },

  mounted() {
    const { backgroundVideo } = this
    const { id } = getVideoId(this.url)
    // Note: to enable the player's background mode
    // which hides the controls, autoplays and loops the
    // video, the account being used must be Plus, PRO,
    // or Business. Then you options object can look like
    //
    // const options = {
    //   id,
    //   background: backgroundVideo
    // }

    // for more information on emebed options
    // https://www.npmjs.com/package/@vimeo/player#embed-options
    const options = {
      id,
      playsinline: backgroundVideo,
      loop: backgroundVideo,
      muted: backgroundVideo,
      autoplay: backgroundVideo,
      background: backgroundVideo,
    }

    if (backgroundVideo) {
      this.toggle = true
    }

    this.player = new Player(this.$el, Object.assign(options, this.options))

    this.player.on('pause', () => {
      if (backgroundVideo && this.toggle) {
        this.player.play()
      }
    })
    this.player.on('timeupdate', ({ percent }) => {
      if (percent > 0.001) {
        if (!this.isPlaying) {
          EventBus.$emit('set:loaded', true)
        }
        this.isPlaying = true
      }
    })
  },

  methods: {
    maybeToggle(buttonId) {
      if (buttonId !== this.playerId) {
        return
      }

      this.toggle = !this.toggle
      this.player[this.toggle ? 'play' : 'pause']()

      if (!this.backgroundVideo) {
        return
      }

      EventBus.$emit('set:playing', {
        id: this.playerId,
        playing: this.toggle,
      })
    },
  },

  render(createElement) {
    const backgroundVideoElement = this.backgroundVideo
      ? createElement('BaseCoverContainer', { props: { isPlaying: this.isPlaying } })
      : createElement('div')
    return backgroundVideoElement
  },
}



// WEBPACK FOOTER //
// ./src/js/components/player/PlayerVimeo.js